import {
  colorError,
  colorInfo,
  colorWarning,
} from '@atlas-frontend/design-tokens';
import { Flex } from 'antd';
import React from 'react';
import { SystemClassifierItem } from '../../systemClassifier/SystemClassifierItem';
import { Bullet } from '../../common/components/Bullet';

export interface ValidationErrorLevelProps {
  itemId?: number;
}

function getColor(code: string) {
  switch (code) {
    case 'ERROR':
      return colorError;
    case 'WARNING':
      return colorWarning;
    default:
      return colorInfo;
  }
}

export function ValidationErrorLevel({ itemId }: ValidationErrorLevelProps) {
  return (
    <SystemClassifierItem
      code="VALIDATION_ERROR_LEVEL"
      itemId={itemId}
      render={(item) => {
        return item?.code ? (
          <Flex align="center" gap={6}>
            <Bullet color={getColor(item.code)} />
            {item.name}
          </Flex>
        ) : (
          <span />
        );
      }}
    />
  );
}
